import React, { useState } from "react";

const FuturesTable = ({ futuresData, onFutureSelect, onFutureBuy, onFutureSell }) => {
  const [hoverIndex, setHoverIndex] = useState(null);
  if (!futuresData || !futuresData.length) {
    return <div className="text-center py-4">No futures data available</div>;
  }

  const getChangeColor = (changeValue) => {
    if (changeValue > 0) return "#5CA81D";
    if (changeValue < 0) return "#DD6565";
    return "#666";
  };

  const calculateOIChange = (currentOI, previousOI) => {
    if (!currentOI || !previousOI || previousOI === 0) return null;
    return (((currentOI - previousOI) / previousOI) * 100).toFixed(2);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-n100 text-n900 text-[10px] text-center bg-n000">
            <th className="p-2 w-32">Scrip</th>
            <th className="p-2 w-32 relative">
              LTP <br />
              <span className="font-medium text-n500 text-[8px]">Change</span>
            </th>
            <th className="p-2 w-32">
              OI <br />
              <span className="font-medium text-n500 text-[8px]">Change</span>
            </th>
            <th className="p-2 w-32">Volume</th>
          </tr>
        </thead>
        <tbody>
          {futuresData.map((future, index) => {
            const ltpChange = future.change_per;
            const oiChange = calculateOIChange(future.oi, future.previous_oi);

            return (
              <tr
                key={index}
                className="border-b border-n100 text-p300 text-[12px] text-center font-medium cursor-pointer hover:bg-n50"
                onClick={() => onFutureSelect && onFutureSelect(future)}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}>
                <td className="p-2 w-32">{future.scrip}</td>

                <td className="p-2 w-32 relative">
                  <div>{future.ltp}</div>
                  {ltpChange !== null && ltpChange !== undefined && (
                    <div
                      className="text-[10px] font-medium"
                      style={{ color: getChangeColor(parseFloat(ltpChange)) }}>
                      ({ltpChange}%)
                    </div>
                  )}
                  
                  {/* Buy/Sell buttons*/}
                  {hoverIndex === index && (
                    <div className="absolute left-[-10px] top-4 flex gap-3 items-center px-2 z-20">
                      <button
                        className="p-2 py-0.5 rounded-sm text-white font-medium bg-p150"
                        onClick={(e) => {
                          e.stopPropagation();
                          onFutureBuy && onFutureBuy(future);
                        }}
                      >
                        Buy
                      </button>
                      <button
                        className="p-2 py-0.5 rounded-sm text-white font-medium bg-red"
                        onClick={(e) => {
                          e.stopPropagation();
                          onFutureSell && onFutureSell(future);
                        }}
                      >
                        Sell
                      </button>
                    </div>
                  )}
                </td>

                <td className="p-2 w-32">
                  <div>{future.oi}</div>
                  {oiChange !== null && (
                    <div
                      className="text-[10px] font-medium"
                      style={{ color: getChangeColor(parseFloat(oiChange)) }}>
                      ({oiChange}%)
                    </div>
                  )}
                </td>

                <td className="p-2 w-32">
                  <div>{future.volume}</div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FuturesTable;